const data = [
    {
        heading: "Brand Recognition",
        description: "Boost your brand recognition with each click. Generic links don’t mean a thing. Branded links help instil confidence in your content.",
        image: "images/icon-brand-recognition.svg",
    },
    {
        heading: "Detailed Records",
        description: " Gain insights into who is clicking your links. Knowing when and where people engage with your content helps inform better decisions.",
        image: "images/icon-detailed-records.svg",
    },
    {
        heading: "Fully Customizable",
        description: " Improve brand awareness and content discoverability through customizable links, supercharging audience engagement.",
        image: "images/icon-fully-customizable.svg",
    },
];

export default data;
